exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._29Mp0{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}._3LNi_{width:46px}.GGPGK{margin-left:8px;margin-left:.5rem;color:#111}", ""]);

// exports
exports.locals = {
	"zsu": "_29Mp0",
	"flag": "_3LNi_",
	"text": "GGPGK"
};